import { XGSSelectOption } from "../../../../ui-components/xgs-select/xgsSelect";

export const EVENT_SOURCE_OPTIONS = {
    "Image Importer": "Image Importer",
    "Invoice Extract": "Invoice Extract",
    "EDIBOL ImageExtract": "EDIBOL ImageExtract",
    "Image Indexer Slow": "Image Indexer Slow",
    "Image Indexer Fast": "Image Indexer Fast",
    "XGS Intranet": "XGS Intranet",
    "GPD Integration": "GPD Integration",
    "McLeod Integration": "McLeod Integration",
    "POD Integration": "POD Integration",
    "Email Extract": "Email Extract",
    "SFTPBOLPOD Integration": "SFTPBOLPOD Integration",
    "Averitt Integration": "Averitt Integration"
  };
  
  export const EVENT_TYPE_OPTIONS: Record<string, Record<string, string>> = {
    "Image Importer": {
      "Import Process": "Import Process",
      "Splitter Process": "Splitter Process",
      "Unlock Process": "Unlock Process"
    },
    "Invoice Extract": {
      "Extract Process": "Extract Process",
      "Print Process": "Print Process",
      "Email Process": "Email Process",
      "Report Process": "Report Process",
      "FTP Process": "FTP Process"
    },
    "EDIBOL ImageExtract": {
      "Process EDI": "Process EDI"
    },
    "Image Indexer Slow": {
      "Index Process": "Index Process"
    },
    "Image Indexer Fast": {
      "Index Process": "Index Process"
    },
    "XGS Intranet": {
      "Invoice Generator": "Invoice Generator",
      "Index Image": "Index Image",
      "Change Image Type": "Change Image Type",
      "Image Viewer": "Image Viewer"
    },
    "GPD Integration": {
      "Copy Process": "Copy Process"
    },
    "McLeod Integration": {
      "Receivables Process": "Receivables Process",
      "Payables Process": "Payables Process"
    },
    "POD Integration": {
      "Main Process": "Main Process",
      "POD Process": "POD Process"
    },
    "Email Extract": {
      "Convert Process": "Convert Process",
      "Receive Process": "Receive Process",
      "Render Process": "Render Process",
      "Import Process": "Import Process",
      "Reveive Process": "Reveive Process"
    },
    "SFTPBOLPOD Integration": {
      "Export Process": "Export Process"
    },
    "Averitt Integration": {
      "Export Process": "Export Process"
    }
  };
  
  export const getEventSourceOptions = () => {
    return Object.keys(EVENT_SOURCE_OPTIONS).map((key) => ({
      value: key,
      label: EVENT_SOURCE_OPTIONS[key]
    }));
  };
  
  export const getEventTypeOptions = (sourceKey: XGSSelectOption | null | undefined) => {
    return EVENT_TYPE_OPTIONS[sourceKey?.value as string]
      ? Object.keys(EVENT_TYPE_OPTIONS[sourceKey?.value as string]).map((key) => ({
          value: key,
          label: EVENT_TYPE_OPTIONS[sourceKey?.value as string][key]
        }))
      : [];
  };
  